import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Refresh = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="m15.196 2.268 1 1.732-2.177 1.257a8 8 0 1 1-6.747 1.289L8.28 8.292a6 6 0 1 0 5.125-1.127l1.327 2.3-1.732 1-3-5.197-.008-.014.057-.014 5.147-2.972Z"
      fill="currentColor"
    />
  </Icon>
));

export default Refresh;
